exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inlearno-spinner{fill:#8e64a8}.inlearno-spinner__circle{-ms-transform-origin:50% 50%;transform-origin:50% 50%;animation:rotate 4s linear infinite}@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39d9bb3a","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ext/Spinner_new.vue
// module id = 07d68eeb935c22dbdceb
// module chunks = 0